//#region src/modules/file-uploader/utils/create-progress.ts
var e = (e) => {
	let t = {
		isUploading: !1,
		progress: 0,
		total: 0,
		isUploaded: !1
	}, n = () => {
		e?.(t);
	}, r = () => {
		t = {
			...t,
			progress: 0,
			total: 0,
			isUploading: !0,
			isUploaded: !1
		}, n();
	}, i = () => {
		t = {
			...t,
			isUploading: !1,
			isUploaded: !0
		}, n();
	}, a = (e, r) => {
		r && (t = {
			...t,
			progress: Math.round(e * 100 / r),
			total: r
		}, n());
	};
	return {
		getState: () => t,
		startProgress: r,
		finishProgress: i,
		updateProgress: a,
		resetProgress: () => {
			t = {
				progress: 0,
				total: 0,
				isUploading: !1,
				isUploaded: !1
			}, n();
		},
		progressHandler: (e) => {
			let t = e.loaded, n = e.total;
			a(t, n);
		}
	};
};
//#endregion
export { e as createProgress };
